// ─── RBAC Roles ────────────────────────────────────────────────────────────
/**
 * Institutional position/cargo of a person in the organization.
 * Semantically distinct from TenantRole (access control) and PersonType lifecycle.
 * A person can hold multiple institutional roles simultaneously.
 * Stored in Person.institutionalRoles[] — never in Membership.
 */
export const INSTITUTIONAL_ROLES = [
    'docente', // Profesor / instructor de cursos
    'tutor', // Tutor académico o pastoral
    'decano', // Decano de facultad o departamento
    'academico', // Funcionario académico (ej. coordinador académico)
    'coordinador', // Coordinador de programa o área
    'capellan', // Capellán / mentor espiritual
    'staff', // Personal administrativo general
    'faculty', // Alias legacy — Docente (backward compat)
];
const FEATURE_FLAG_DEFS = {
    donations: { scope: 'tenant', default: false },
    mentor_module: { scope: 'tenant', default: false },
    mfa_required: { scope: 'tenant', default: false },
    crm_campaigns: { scope: 'tenant', default: false },
    student_portal: { scope: 'tenant', default: false },
    course_materials: { scope: 'tenant', default: false },
    lms_modules: { scope: 'tenant', default: false },
    course_templates: { scope: 'tenant', default: false },
    lms_assignments: { scope: 'tenant', default: false },
    notifications: { scope: 'tenant', default: true },
    notifications_email: { scope: 'tenant', default: true },
    notifications_push: { scope: 'tenant', default: true },
    lms_integration_stub: { scope: 'tenant', default: false }, // Reserved for future LMS hook
    aiImport: { scope: 'tenant', default: true }, // PDF/document import for course templates
    assistedReview: { scope: 'tenant', default: true }, // AI-assisted submission review
    // `graduation_audit` (expediente por credenciales) se retiró en M4·D1 paso 5:
    // hoy es configuración con nombre, `config.academicRecord`.
};
export const FEATURE_FLAGS = FEATURE_FLAG_DEFS;
export const FEATURE_FLAG_KEYS = Object.keys(FEATURE_FLAGS);
export function isFeatureFlagKey(key) {
    return Object.prototype.hasOwnProperty.call(FEATURE_FLAGS, key);
}
/** The effective value: the explicit switch if there is one, else the flag's
 *  default. `enabledFeatures` may be missing on legacy tenant docs. */
export function resolveFeatureFlag(enabledFeatures, key) {
    return enabledFeatures?.[key] ?? FEATURE_FLAGS[key].default;
}
//# sourceMappingURL=index.js.map